import { useState, useEffect } from 'react';
import { CurrentTimeIndicatorStyles, CurrentTimeIndicatorStylesCurrentDay } from './CurrentTimeIndicatorStyles';
import { ONE_MINUTE_IN_MILLISECONDS } from '../../constants/time';
import { useTheme } from '../../lib/styles';
import { getCachedMoment } from '../../lib/time';
import { useCalendarProps } from '../../internal/CalendarPropsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const getDate = ({
  _incrementCurrentTime,
  timezone,
  currentTime
}) => {
  return _incrementCurrentTime || !currentTime ? getCachedMoment(Date.now(), timezone, true) : getCachedMoment(currentTime, timezone);
};
export default function CurrentTimeIndicator({
  currentTime,
  isCurrentDay,
  _incrementCurrentTime
}) {
  const {
    uiAddonCalendars: {
      dayView: {
        hourHeight
      },
      util: {
        getCurrentTimeTopPosition
      }
    }
  } = useTheme();
  const {
    timezone
  } = useCalendarProps();
  const [top, setTop] = useState(0);
  useEffect(() => {
    let updateTopPosition;
    const initialDate = getDate({
      _incrementCurrentTime,
      timezone,
      currentTime
    });

    // update position whenever the props change
    setTop(getCurrentTimeTopPosition({
      hours: initialDate.hours(),
      minutes: initialDate.minutes()
    }));

    // update position every minute
    if (_incrementCurrentTime) {
      updateTopPosition = setInterval(() => {
        const nextDate = getDate({
          _incrementCurrentTime,
          timezone,
          currentTime
        });
        setTop(getCurrentTimeTopPosition({
          hours: nextDate.hours(),
          minutes: nextDate.minutes()
        }));
      }, ONE_MINUTE_IN_MILLISECONDS);
    }
    return () => {
      if (updateTopPosition) {
        clearInterval(updateTopPosition);
      }
    };
  }, [hourHeight, currentTime, timezone, _incrementCurrentTime, getCurrentTimeTopPosition]);
  if (isCurrentDay) {
    return /*#__PURE__*/_jsx(CurrentTimeIndicatorStylesCurrentDay, {
      "data-top": top,
      top: top
    });
  }
  return /*#__PURE__*/_jsx(CurrentTimeIndicatorStyles, {
    "data-top": top,
    top: top
  });
}